'use strict'

angular.module('internal.admin', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // admin tab
            .state('internal.admin.enterprise', {
                abstract: true,
                templateUrl: paths.app + 'admin/components/admin-enterprise/admin-enterprise.html',
                controller: 'InternalAdminEnterprise',
                params: {
                    id: null,
                    enterprise: null
                }
            })
                .state('internal.admin.enterprise.settings', {
                    abstract: true,
                    templateUrl: paths.app + 'admin/components/admin-enterprise-settings/admin-enterprise-settings.html',
                    controller: 'InternalAdminEnterpriseSettings',
                    params: {
                        id: null,
                        enterprise: null
                    }
                })
                .state('internal.admin.enterprise.settings.optionalfields', {
                        url: '/admin/enterprise/:id/settings/optionalfields',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-optionalfields/admin-enterprise-optionalfields.html',
                        controller: 'InternalAdminEnterpriseSettingsOptionalFields',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                    if (!access) {
                                        //$state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                .state('internal.admin.enterprise.dataexchange', {
                    abstract: true,
                    templateUrl: paths.app + 'admin/components/admin-enterprise-dataexchange/admin-enterprise-dataexchange.html',
                    controller: 'InternalAdminEnterpriseDataExchange',
                    params: {
                        id: null,
                        enterprise: null
                    }
                })
                .state('internal.admin.enterprise.integrations', {
                    abstract: true,
                    templateUrl: paths.app + 'admin/components/admin-enterprise-dataexchange/admin-enterprise-dataexchange.html',
                    controller: 'InternalAdminEnterpriseDataExchange',
                    params: {
                        id: null,
                        enterprise: null
                    }
                })
                    .state('internal.admin.enterprise.integrations.azure', {
                        url: '/admin/enterprise/:id/integrations/azure',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions){
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.backgroundchecks', {
                        url: '/admin/enterprise/:id/integrations/backgroundchecks',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.compactintegration', {
                        url: '/admin/enterprise/:id/integrations/compactintegration',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.ftpendpoints', {
                        url: '/admin/enterprise/:id/integrations/ftpendpoints',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.ftpendpoint', {
                        url: '/admin/enterprise/:id/integrations/ftpendpoints/:integrationId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null,
                            integrationId: 'create'
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.integrationaccount', {
                        url: '/admin/enterprise/:id/integrations/integrationaccounts/:endpointId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null,
                            endpointId: 'create'
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                })
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.identityprovider', {
                        url: '/admin/enterprise/:id/integrations/identityprovider',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.identityproviderdetails', {
                        url: '/admin/enterprise/:id/integrations/identityprovider/:identityProviderId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.integrationaccounts', {
                        url: '/admin/enterprise/:id/integrations/integrationaccounts',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.learningmanagement', {
                        url: '/admin/enterprise/:id/integrations/learningmanagement',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.mfrimoodle', {
                        url: '/admin/enterprise/:id/integrations/mfrimoodle',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.nationalregistry', {
                        url: '/admin/enterprise/:id/integrations/nationalregistry',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.paymentgateway', {
                        url: '/admin/enterprise/:id/integrations/paymentgateway',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.locations', {
                        url: '/admin/enterprise/:id/integrations/locations',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.juvareexport', {
                        url: '/admin/enterprise/:id/integrations/juvareexport',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.juvareexports', {
                        url: '/admin/enterprise/:id/integrations/juvareexport/:integrationId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null,
                            integrationId: 'create'
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.juvareexportlog', {
                        url: '/admin/enterprise/:id/integrations/juvareexportlog',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.juvareexportlogpage', {
                        url: '/admin/enterprise/:id/integrations/juvareexportlog/:integrationId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null,
                            integrationId: null,
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.loggingaccount', {
                        url: '/admin/enterprise/:id/integrations/loggingaccounts/:loggingSetupId',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null,
                            loggingSetupId: 'create'
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                })
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.loggingaccounts', {
                        url: '/admin/enterprise/:id/integrations/loggingaccounts',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                });
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.integrations.emailprovider', {
                        url: '/admin/enterprise/:id/integrations/emailprovider',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-integrations/admin-enterprise-react.html',
                        controller: 'InternalAdminReactIntegrations',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                })
                            }]
                        }
                    })
                    .state('internal.admin.enterprise.datachangelog', {
                        abstract: true,
                        templateUrl: paths.app + 'admin/components/admin-enterprise-datachangelog/admin-enterprise-datachangelog.html',
                        controller: 'InternalAdminEnterpriseDataChangeLog',
                        params: {
                            id: null,
                            enterprise: null
                        }
                    })
                    .state('internal.admin.enterprise.datachangelog.history', {
                        url: '/admin/enterprise/:id/datachangelog/history',
                        templateUrl: paths.app + 'admin/components/admin-enterprise-history/admin-enterprise-history.html',
                        controller: 'InternalAdminHistory',
                        params: {
                            id: null,
                            enterprise: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.self.name).then(function (access) {
                                    if (!access) {
                                        //$state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
    }])
;